import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";


export const loadSalaryStructureDetailByID = async (payload) => {
    try {       

        return await callApi(API_ENDPOINTS.SALARY_STRUCTURE_DETAIL_BY_ID, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error loading salary structure detail:", error);
        throw error;
    }

};

export const loadSalaryStructureDetail = async (payload) => {
    try {       

        return await callApi(API_ENDPOINTS.HR_SALARY_COMPONENTS_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error loading salary structure detail:", error);
        throw error;
    }

};